exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".select-img-container{background-size:contain!important;border:1px solid #f1eeea;border-radius:50px;display:block;margin:30px auto;text-align:center;max-width:375px}.canvas-cursor{cursor:url(\"/src/assets/images/select-cursor.cur\"),text}@media (max-width:768px){.select-img-container{background-size:contain!important}}.select-img-container.right-breast{background:url(\"/src/assets/images/right-breast-shape.svg\") 50% no-repeat}.select-img-container.left-breast{background:url(\"/src/assets/images/left-breast-shape.png\") 50% no-repeat}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ddd8a6a0","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modals/main-survey/survey-step3-q2.vue
// module id = 894
// module chunks = 0